import {
  mapDispatchNextPage,
  mapStateToPropsNextButton
} from 'reg_redesign/redux/connectFunctions';
import CtaButton from '@opploans/cta-button-component/CtaButton';

const nextButtonConfig = (page) => ({
  component: CtaButton,
  name: 'ContinueButton',
  dispatchOverride: mapDispatchNextPage,
  props: {
    id: 'submitButton',
    additionalStyle: {
      fontSize: '1rem',
      height: '3.5rem',
      marginTop: '2.5rem',
      width: '100%'
    },
    children: 'Next',
    page
  },
  stateToPropsOverride: mapStateToPropsNextButton
});

export default nextButtonConfig;
